import React, { useCallback, useEffect, useMemo, useState } from 'react';
import bem from 'utils/bem.js';
import { useRoomContext } from '../contexts/RoomContext';
import { RoomActions } from './RoomActions';
import { useParticipants } from '../utils/hooks/useParticipants';
import { MainVideo } from './MainVideo';
import { LocalVideo } from './LocalVideo';
import { getBrowser, getOS } from '../utils/os';
import './index.sass';
import { useFullscreen } from '../utils/hooks/useFullscreen';
import { useIOSFullscreen } from '../utils/hooks/useIOSFullscreen';
import { NoUserPlaceholder } from '../NoUserPlaceholder';

const { block, el } = bem('room');

export const Room = () => {
    const { room } = useRoomContext();
    const [ roomElement, setRoomElement ] = useState<HTMLDivElement | null>(null);
    const { localParticipantId, remoteParticipantId } = useParticipants(room);
    const storeRoomElement = useCallback((node) => setRoomElement(node), []);
    const isIOS = useMemo(() => getOS() === 'iOS', []);
    const isFirefox = useMemo(() => getBrowser() === 'Firefox', []);
    const { isFullscreen, toggleFullscreen } = isIOS || isFirefox ? useIOSFullscreen(roomElement) : useFullscreen(roomElement);

    if (!remoteParticipantId) {
        return (
            <div className={block({'fullscreen': isFullscreen})} ref={storeRoomElement}>
                <NoUserPlaceholder />
                <LocalVideo participantId={localParticipantId} />
                <RoomActions isFullscreen={isFullscreen} toggleFullscreen={toggleFullscreen} container={roomElement} />
            </div>
        )
    }

    return (
        <div className={block()} ref={storeRoomElement}>
            <MainVideo participantId={remoteParticipantId} isFullscreen={isFullscreen} />
            <LocalVideo participantId={localParticipantId} />
            <RoomActions isFullscreen={isFullscreen} toggleFullscreen={toggleFullscreen} container={roomElement}/>
        </div>
    )
}
